<template>
  <div id="logreg">
    <div class="header">
        <!-- <router-link class="logo" to="/">
          <img src="../assets/images/logo.png" />
        </router-link> -->
    </div>
    <div class="body_main"  v-if="onShow">
      <div class="yu_boxs">
        <h3>登录</h3>
        <div class="line1"></div>
        <div class="label tels" :class="errtels == 1 ? 'active' : ''">
          <i class="left"></i>
          <input
            type="text"
            v-model="telephone"
            maxlength="11"
            placeholder="请输入手机号码"
            @focus="tels"
          />
          <i class="right" @click="telclo"></i>
        </div>
        <!-- <div class="label code" :class="errcode == 1 ? 'active' : ''">
          <input
            type="text"
            v-model="authCode"
            maxlength="6"
            placeholder="请输入短信验证码"
            @focus="code"
            @input="codeInput(authCode)"
          />
          <span @click="onCode">{{codeTitle}}</span>
        </div> -->
        <div class="errmes" v-if="errMes == 1">
          <i></i>
          {{message}}
        </div>
        <div class="remind">
          未注册的手机号验证后将自动创建搜精品账号
        </div>
        <div class="agree">
          <div class="left" :class="agree == 1 ? 'active' : ''" @click="agreeLeft"></div>
          <div class="right">
            已阅读并同意搜精品账号
            <a
              href="https://www.soujingpin.com/style/html/userRegistrationProtocol.html"
              target="_blank"
            >注册协议</a>和
            <a
              href="https://www.soujingpin.com/style/html/platformPrivacyPolicy.html"
              target="_blank"
            >隐私政策</a>
          </div>
        </div>
        <div class="login" @click="onLoginXyb">下一步</div>
      </div>
    </div>
    <div class="body_main" v-if="!onShow">
      <div class="yu_boxs">
        <h3>登录</h3>
        <div class="line1"></div>
        <div class="sendYzm">
          验证码已发送{{telephone}}
          <div class="modifyPhone"  @click="onModifyPhone">
            修改
          </div>
        </div>
        <div class="label1 tels" :class="errtels == 1 ? 'active' : ''">
          <input
            type="text"
            v-model="authCode"
            maxlength="6"
            placeholder="请输入短信验证码"
            @focus="code"
            @input="codeInput(authCode)"
          />
          <span @click="onCode">{{codeTitle}}</span>
        </div>
        <div class="login1" @click="onLogin">登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "../bus.js";
import { getAuthCode, webLogreg } from "@/api/logreg";
import { memberInfo } from "@/api/memberCenter";
export default {
  name: "logreg",
  data() {
    return {
      onShow: true,
      telephone: "",
      authCode: "",
      sortCode: "", // 纠正密码
      errtels: 0, // 手机号错误框
      errcode: 0, // 验证码错误框
      codeTitle: "获取验证码",
      second: 29, // 倒计时
      message: "", // 错误提示文字
      errMes: 0, // 错误显示
      agree: 1 // 默认协议
    };
  },
  created() {},
  methods: {
    // 获取验证码
    onCode() {
      let _this = this;
      _this.message = "";
      _this.errMes = 0;
      _this.errcode = 0;
      if (_this.codeTitle == "获取验证码") {
        let myreg = /^1[345789]\d{9}$/;
        if (_this.telephone.length == 0) {
          _this.message = "请输入手机号";
          _this.errMes = 1;
          _this.errtels = 1;
          return false;
        } else if (!myreg.test(_this.telephone)) {
          _this.message = "手机号格式错误";
          _this.errMes = 1;
          _this.errtels = 1;
          return false;
        } else {
          _this.codeTitle = "29秒后重发";
          _this.timer();
          setTimeout(async function() {
            const res = await getAuthCode({
              telephone: _this.telephone
            });
            if (res.code == 200) {
              // _this.authCode = res.data
              _this.sortCode = res.data
            }
          }, 1000);
        }
      }
    },
    // 倒计时
    timer() {
      let _this = this;
      let promise = new Promise((resolve, reject) => {
        let setTimer = setInterval(() => {
          var second = _this.second - 1;
          _this.second = second;
          _this.codeTitle = second + "秒后重发";
          if (_this.second <= 0 || _this.loginShow == 0) {
            _this.second = 29;
            _this.codeTitle = "获取验证码";
            resolve(setTimer);
          }
        }, 1000);
      });
      promise.then(setTimer => {
        clearInterval(setTimer);
      });
    },
    // 手机号获取焦点
    tels() {
      this.message = "";
      this.errMes = 0;
      this.errtels = 0;
    },
    // 清空手机号
    telclo() {
      this.telephone = "";
      this.message = "";
      this.errMes = 0;
      this.errtels = 0;
    },
    // 验证码获取焦点
    code() {
      this.message = "";
      this.errMes = 0;
      this.errcode = 0;
    },
    codeInput(e){
      this.authCode = e
    },
    onLoginXyb() {
      console.log();
      let _this = this;
      let myreg = /^1[345789]\d{9}$/;
      if (_this.telephone.length == 0) {
        // _this.message = "请输入手机号";
        // _this.errMes = 1;
        // _this.errtels = 1;
        this.$message.error('请输入手机号');
        return false;
      } else if (!myreg.test(_this.telephone)) {
        // _this.message = "手机号格式错误";
        // _this.errMes = 1;
        // _this.errtels = 1;
        this.$message.error('手机号格式错误');
        return false;
      } else if (_this.agree == 0) {
      // _this.message = "您需要同意相关条款才能使用";
      // _this.errMes = 1;
      this.$message.error('您需要同意相关条款才能使用');
      return false;
      } else {
        _this.onCode();
        _this.onShow = false
      }
    },
    onModifyPhone() {
      this.onShow = true
    },
    async onLogin() {
    //onLogin() {  
      console.log();
      let _this = this;
      let myreg = /^1[345789]\d{9}$/;
      if (_this.telephone.length == 0) {
        // _this.message = "请输入手机号";
        // _this.errMes = 1;
        // _this.errtels = 1;
        this.$message.error('请输入手机号');
        return false;
      } else if (!myreg.test(_this.telephone)) {
        // _this.message = "手机号格式错误";
        // _this.errMes = 1;
        // _this.errtels = 1;
        this.$message.error('手机号格式错误');
        return false;
        } else if (_this.agree == 0) {
        // _this.message = "您需要同意相关条款才能使用";
        // _this.errMes = 1;
        this.$message.error('您需要同意相关条款才能使用');
        return false;
      } else if (_this.authCode.length == 0) {
        // _this.message = "请输入短信验证码";
        // _this.errMes = 1;
        // _this.errcode = 1;
        this.$message.error('请输入短信验证码');
        return false;
      } else if (isNaN(_this.authCode) || _this.authCode.length < 6) {
        console.log(isNaN(_this.authCode));
        // _this.message = "短信验证码格式错误";
        // _this.errMes = 1;
        // _this.errcode = 1;
        this.$message.error('短信验证码格式错误');
        return false;
      } else {
        try {
          const res = await webLogreg({
          //const res = webLogreg({  
            telephone: _this.telephone,
            authCode: _this.authCode
          });
          console.log("######");
          console.log(res.code);
          if (res.code === 500) {
            console.log("!!!!!!");
            this.$message.error('短信验证码验证失败');
            return false;
          }
          if (res.code === 200) {
            localStorage.setItem("userToken", res.data);
            console.log(localStorage.getItem("userToken"));
            const resMember = await memberInfo();
             console.log("@@@@@@");
            console.log(resMember.code);
            if (resMember.code === 200) {
              let logout = {
                icon: resMember.data.icon,
                nick: resMember.data.nickname,
                phone: resMember.data.phone
              };
              console.log("@@@@@@");
              console.log(resMember);
              console.log(JSON.stringify(logout));
              localStorage.setItem("userInfo", JSON.stringify(logout));
              localStorage.setItem("carnum", resMember.data.cartItemNum);
              // this.$nextTick(function() {
              //   Bus.$emit("userInfo", logout);
              // });
            }
            console.log("!!!!!!!!!!@@@@@@");
            _this.$router.push({
              path: "/"
            });
          } else {
            // _this.message = "请输入正确的短信验证码";
            // _this.errMes = 1;
            this.$message.error('短信验证码验证失败');
            return false;
          }
        } catch (err) {
          this.$message.error('短信验证码验证失败');
          return false;
          //console.log(err)
        }
      }
    },
    // 协议
    agreeLeft() {
      this.agree == 1 ? (this.agree = 0) : (this.agree = 1);
      this.message = "";
      this.errMes = 0;
    }
  },
  mounted() {}
  // beforeDestroy() {
  //   Bus.$emit("getUser",'----------------------------------------------------------');
  // }
};
</script>

<style lang="less" scoped>
#logreg {
  // position: relative;
  // z-index: 3;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
    width: 1920px;
    height: 1080px;
  .header {
    width: 400px;
    height: 1080px;
    background-image: url("../assets/images/logreg_11.png");
    background-size: 100% 100%;
  }
  .body_main {
    width: 1520px;
    height: 1080px;
    background: #fff;
    padding-left: 550px;
    padding-top: 243px;
    // background: url("../assets/images/logreg_1.jpg");
    // background-size: 100% 100%;
    .height600 {
      height: 600px;
    }
    .yu_boxs {
      width: 420px;
      height: 491px;
      background: #FFFFFF;
      box-shadow: 0px 0px 50px 0px rgba(135,135,135,0.1);
      border-radius: 8px;
      h3 {
        padding-left: 43px;
        padding-top: 37px;
        width: 96px;
        height: 33px;
        font-size: 24px;
        font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
        font-weight: 500;
        color: #222222;
        line-height: 33px;
      }
      .line1 {
        margin-left: 43px;
        margin-top: 35px;
        width: 48px;
        height: 6px;
        background: #E71D35;
        border-radius: 3px;
      }
      .label {
        margin-top: 64px;
        margin-left: 40px;
        width: 340px;
        height: 60px;
        background: #F9F9F9;
        // margin-bottom: 14px;
        // border: 1px solid rgba(218, 218, 218, 1);
        //border-radius: 2px;
        //position: relative;
        //overflow: hidden;
        &.active {
          border-color: #d4282d;
        }
        .left,
        .right {
          background-image: url("../assets/images/icon_0.png");
          background-repeat: no-repeat;
        }
        .left {
          float: left;
          width: 12px;
          height: 20px;
          margin: 22px;
          background-position: -38px -122px;
          position: relative;
          // &::before {
          //   content: "";
          //   width: 1px;
          //   height: 22px;
          //   background: #dadada;
          //   overflow: hidden;
          //   position: absolute;
          //   top: -2px;
          //   right: -10px;
          // }
        }
        .right {
          float: right;
          width: 16px;
          height: 16px;
          margin: 10px 12px;
          background-position: -50px -122px;
          cursor: pointer;
          display: none;
        }
        &.code input {
          width: 186px;
        }
        input {
          float: left;
          width: 111px;
          height: 22px;
          line-height: 36px;
          margin-top: 19px;
          border: none;
          font-size: 16px;
          font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
          font-weight: 400;
          background: #F9F9F9;
          color: #333;
          line-height: 22px;
        }
        span {
          float: right;
          color: #333;
          width: 88px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          background: #eee;
          cursor: pointer;
        }
      }
      .errmes {
        color: #d4282d;
        font-size: 12px;
        line-height: 13px;
        margin-top: -7px;
        overflow: hidden;
        i {
          float: left;
          width: 13px;
          height: 13px;
          margin-right: 5px;
          background-image: url("../assets/images/icon_0.png");
          background-repeat: no-repeat;
          background-position: -66px -122px;
        }
      }
      .remind {
        margin-top: 10px;
        padding-left: 40px;
        width: 287px;
        height: 17px;
        font-size: 12px;
        font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
      }
      .agree {
        margin-top: 20px;
        padding-left: 40px;
        width: 100%;
        overflow: hidden;
        .left {
          float: left;
          width: 19px;
          height: 19px;
          margin-right: 5px;
          cursor: pointer;
          background-image: url("../assets/images/icon_0.png");
          background-position: 0 -122px;
          &.active {
            background-position: -19px -122px;
          }
        }
        .right {
          float: left;
          color: #999;
          font-size: 14px;
          line-height: 19px;
          a {
            color: #333;
            font-size: 14px;
            line-height: 19px;
            display: inline-block;
            vertical-align: top;
          }
        }
      }
      .login {
        margin-top: 30px;
        margin-left: 40px;
        width: 340px;
        height: 50px;
        background-color: #E71D35;
        border-radius: 2px;
       
        color: #fff;
        font-size: 20px;
        text-align: center;
        line-height: 48px;
        margin: 26px auto 12px;
      }
      .login1 {
        margin-top: 30px;
        margin-left: 40px;
        width: 340px;
        height: 60px;
        background-color: #E71D35;
        border-radius: 2px;
        color: #fff;
        font-size: 16px;
        text-align: center;
        line-height: 56px;
        font-family: PingFangSC-Regular, PingFang SC;
        margin: 26px auto 12px;
      }
      .sendYzm {
        margin-left: 43px;
        margin-top: 77px;
        width: 338px;
        height: 25px;
        font-size: 18px;
        font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
        font-weight: 400;
        color: #000000;
        line-height: 25px;
        
        .modifyPhone {
          float: right;
          width: 32px;
          height: 22px;
          font-size: 16px;
          font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
          font-weight: 400;
          color: #E71D35;
          line-height: 22px;
        }
      }
      .label1 {
        margin-top: 36px;
        margin-left: 40px;
        width: 340px;
        height: 60px;
        background: #F9F9F9;
        // margin-bottom: 14px;
        // border: 1px solid rgba(218, 218, 218, 1);
        //border-radius: 2px;
        //position: relative;
        //overflow: hidden;
        input {
          float: left;
          width: 111px;
          height: 22px;
          line-height: 36px;
          margin-top: 19px;
          margin-left: 20px;
          border: none;
          font-size: 16px;
          font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
          font-weight: 400;
          background: #F9F9F9;
          color: #333;
          line-height: 22px;
        }
        span {
          float: right;
          margin-top: 12px;
          margin-right: 20px;
          color: #333;
          width: 88px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          background: #eee;
          cursor: pointer;
        }
      }
    }
  }
}
</style>